<template>
  <div class="menu--mobile">
    <v-dialog
      class="mobile__menu"
      v-model="displayMobileMenu"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ props }">
        <div class="menu__container">
          <v-icon class="mobile-menu__icon" v-bind="props">mdi-menu</v-icon>
        </div>
      </template>

      <v-card class="mobile-menu__card">
        <v-card-title>
          <v-row class="mobile-menu__card-title-row">
            <v-col cols="6">
              <h3 class="mobile-menu__title dms400">DIGU</h3>
            </v-col>
            <v-col cols="3" class="close-button-container">
              <v-icon @click="displayMobileMenu = false" class="close-btn">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-list class="mobile-menu__list">
            <!-- Home -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text>
                <a class="m400 mobile-menu__link link--primary" href="/">Home</a>
              </v-list-item-text>
            </v-list-item>

            <!-- About -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text>
                <a class="m400 mobile-menu__link link--primary" href="/about">About</a>
              </v-list-item-text>
            </v-list-item>

            <!-- DIGU Cares (dropdown) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                <v-expansion-panels style="padding: 0" class="ep">
                  <v-expansion-panel
                    elevation="0"
                    style="background-color: transparent; padding-left: 0"
                  >
                    <v-expansion-panel-title>
                      <p class="m400 mobile-menu__link link--primary">DIGU Cares</p>
                      <template v-slot:actions="{ expanded }">
                        <v-icon
                          color="white"
                          :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                        />
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="faq__answer">
                      <v-list class="mobile-menu__list list--secondary">
                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/grassroot-impact-initative">
                              Grassroot Impact Initiative
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/impact-stories">
                              Impact Stories
                            </a>
                          </v-list-item-text>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-text>
            </v-list-item>

            <!-- For Businesses (dropdown) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                <v-expansion-panels style="padding: 0" class="ep">
                  <v-expansion-panel
                    elevation="0"
                    style="background-color: transparent; padding-left: 0"
                  >
                    <v-expansion-panel-title>
                      <p class="m400 mobile-menu__link link--primary">For Businesses</p>
                      <template v-slot:actions="{ expanded }">
                        <v-icon color="white" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="faq__answer">
                      <v-list class="mobile-menu__list list--secondary">
                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/why-digu-for-businesses">
                              Why DIGU for Businesses
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/customers">
                              Customer Stories
                            </a>
                          </v-list-item-text>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-text>
            </v-list-item>

            <!-- Our Solutions (dropdown) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                <v-expansion-panels style="padding: 0" class="ep">
                  <v-expansion-panel
                    elevation="0"
                    style="background-color: transparent; padding-left: 0"
                  >
                    <v-expansion-panel-title>
                      <p class="m400 mobile-menu__link link--primary">Our Solutions</p>
                      <template v-slot:actions="{ expanded }">
                        <v-icon color="white" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="faq__answer">
                      <v-list class="mobile-menu__list list--secondary">
                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/design-my-app">
                              Design My App
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/build-my-app">
                              Build My App
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/review-my-app">
                              Review My App
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/roadmap-my-app">
                              Roadmap My App
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/staff-augmentation">
                              Staff Augmentation
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/implement-identity-management">
                              Identity Management for My App
                            </a>
                          </v-list-item-text>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-text>
            </v-list-item>

            <!-- Packages (single link) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text>
                <a
                  class="m400 mobile-menu__link link--primary"
                  href="/service-packages/custom-web-mobile-ux-ui-design"
                >
                  Packages
                </a>
              </v-list-item-text>
            </v-list-item>

            <!-- For Job Seekers (dropdown) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                <v-expansion-panels style="padding: 0" class="ep">
                  <v-expansion-panel
                    elevation="0"
                    style="background-color: transparent; padding-left: 0"
                  >
                    <v-expansion-panel-title>
                      <p class="m400 mobile-menu__link link--primary">For Job Seekers</p>
                      <template v-slot:actions="{ expanded }">
                        <v-icon color="white" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="faq__answer">
                      <v-list class="mobile-menu__list list--secondary">
                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/why-digu-for-career-opportunities">
                              Why DIGU for Career Opportunities
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/remote-career">
                              Learn about our Remote Career Acceleration Program
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/verified-badges">
                              Verified Badges
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/talents-on-demand">
                              Join our Talent Pool
                            </a>
                          </v-list-item-text>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-text>
            </v-list-item>

            <!-- Resources (dropdown) -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                <v-expansion-panels style="padding: 0" class="ep">
                  <v-expansion-panel
                    elevation="0"
                    style="background-color: transparent; padding-left: 0"
                  >
                    <v-expansion-panel-title>
                      <p class="m400 mobile-menu__link link--primary">Resources</p>
                      <template v-slot:actions="{ expanded }">
                        <v-icon color="white" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="faq__answer">
                      <v-list class="mobile-menu__list list--secondary">
                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/blogs-and-insights">
                              Blogs and Insights
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/experience-nepal">
                              Experience Nepal
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/learning-hub">
                              Learning Hub
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/events">
                              Upcoming Events
                            </a>
                          </v-list-item-text>
                        </v-list-item>

                        <v-list-item density="compact" class="mobile-menu__list-item">
                          <v-list-item-text class="mobile-menu__list-item-text menu-text--secondary">
                            <a class="m400 mobile-menu__link link--secondary" href="/trainings-and-certifications">
                              Trainings and Certifications
                            </a>
                          </v-list-item-text>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-text>
            </v-list-item>

            <!-- Schedule a Meeting -->
            <v-list-item density="compact" class="mobile-menu__list-item">
              <v-list-item-text>
                <a class="m400 mobile-menu__link link--primary calendy-link" @click="redirectToCalendly">
                  Schedule a Meeting
                </a>
              </v-list-item-text>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  data: () => ({
    displayMobileMenu: false,
  }),
  methods: {
    goToImpactMeter() {
      this.displayMobileMenu = false;
      this.$router.push('/').then(() => {
        setTimeout(() => {
          const impactMeterSection = document.getElementById('impactMeter');
          if (impactMeterSection) {
            const elementPosition =
              impactMeterSection.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: elementPosition, behavior: 'smooth' });
          }
        }, 100);
      });
    },
    redirectToCalendly() {
      window.open(process.env.VUE_APP_CALENDLY_LINK, '_blank');
    },
  },
};
</script>

<style scoped>
@media only screen and (min-width: 1282px) {
  .menu--mobile {
    display: none;
  }
}

.mobile-menu__icon {
  color: var(--primary-color);
  font-size: 2rem;
}

.menu__container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.mobile__menu {
  background-color: #292929ee;
  backdrop-filter: blur(10px);
}

.mobile-menu__card {
  background: transparent;
  padding: 2rem;
  padding-bottom: 5rem;
}

.mobile-menu__card-title-row {
  justify-content: space-between;
}

.mobile-menu__title {
  font-size: 1.2rem;
  letter-spacing: 0;
  color: var(--secondary-color-lightest);
}

@media only screen and (min-width: 394px) {
  .mobile-menu__title {
    font-size: 1.5rem;
  }
}

.close-button-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.close-btn {
  color: var(--secondary-color-lightest);
  font-size: 1.5rem !important;
}

.mobile-menu__list {
  background: transparent;
}

.mobile-menu__link {
  text-decoration: none;
  color: var(--light-1);
}

.link--primary {
  font-size: 1.4rem;
  font-weight: 700;
}

.calendy-link {
  cursor: pointer;
}

.link--secondary {
  font-size: 1.2rem;
  font-weight: 500;
}

/* keep titles flush left */
.v-expansion-panel-title {
  padding-left: 0 !important;
}

/* --- SPACING SYSTEM --- */
/* Only top-level list items define vertical rhythm */
.mobile-menu__list-item {
  min-height: 68px !important;
  margin-bottom: 1rem; /* single consistent gap between sections */
}

/* Remove extra margins/padding introduced by expansion panels */
.ep,
.ep .v-expansion-panel,
.ep .v-expansion-panel-title {
  margin: 0 !important;
}

.ep .v-expansion-panel-text {
  padding-top: 0 !important;
  padding-bottom: 0 !important; /* prevents double gap after dropdowns */
}

/* Inner (dropdown) list items have tighter spacing and no external margin */
.list--secondary .mobile-menu__list-item {
  margin-bottom: 0 !important;
  min-height: 48px !important;
}

.list--secondary .mobile-menu__list-item:last-child {
  margin-bottom: 0 !important;
}
</style>
